var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container_all"},[_c('imageholder'),_c('div',{staticClass:"project_containerw"},[_c('initialinfo'),_c('problem'),_c('research'),_c('DefineIdeate'),_c('prototype')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }